export const gtmConfig = {
    containerId: process.env.NEXT_PUBLIC_GTM_CONTAINER_ID,
  };